import React, { HTMLAttributes } from 'react';
import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import c from 'classnames';
import { Button } from '../../../components';
import useClasses from '../../../hooks/useClasses';
import { ImmutableParagraphCtaEntity } from '..';

import './style.scss';

interface Props extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableParagraphCtaEntity;
}

const ParagraphCta: React.FC<Props> = ({ entity, className }) => {
  const { buildClass, joinClasses } = useClasses('ParagraphCta');

  const title = entity.getIn(['field_title', 0, 'value'], '');
  const text = entity.getIn(['field_text', 0, 'processed'], '');
  const link: string = String(entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri'])));
  const linkTitle: string = String(entity.getIn(['field_link', 0, 'title'], ''));

  const gridClasses = c('col-lg-6 offset-lg-3 col-md-10 offset-md-1 col-sm-12 col-12');

  return (
    <article className={joinClasses(className, buildClass())}>
      <div className="row">
        <div className={gridClasses}>
          {title && <h1 className={buildClass('title')}>{title}</h1>}
          {text && (
            <WysiwygField
              property="schema:text"
              className={joinClasses(buildClass('text'), 'body--large')}
              html={text}
            />
          )}
          {(linkTitle && link) && (
            <Button href={link} inverted className={buildClass('link')}>
              { linkTitle }
            </Button>
          )}
        </div>
      </div>
    </article>
  );
};

export default ParagraphCta;
